import {
  FETCH_LANGUAGE,
  FETCH_LANGUAGE_SUCCESS,
  FETCH_LANGUAGE_FAILED,
  EDIT_LANGUAGE
} from "../store/types";
import { getSupabase } from "../config/configureSupabase";

import ptTranslations from "../locales/pt/translation.json";

const defaultLanguageData = {
  defaultLanguage: 'pt',
  langlist: [{
    id: 'pt',
    langLocale: 'pt',
    dateLocale: 'pt-br',
    default: true,
    keyValuePairs: ptTranslations
  }]
};

export const fetchLanguages = () => async (dispatch) => {
  dispatch({
    type: FETCH_LANGUAGE,
    payload: null
  });

  const supabase = getSupabase();
  if (supabase) {
    try {
      const { data, error } = await supabase.from('languages').select('*');
      if (!error && data && data.length > 0) {
        let defLang = 'pt';
        const arr = data.map(l => {
          if (l.default) defLang = l.keyValuePairs || 'pt';
          if (l.dateLocale) l.dateLocale = l.dateLocale.toLowerCase();
          return l;
        });
        dispatch({
          type: FETCH_LANGUAGE_SUCCESS,
          payload: {
            defaultLanguage: defLang,
            langlist: arr
          }
        });
        return;
      }
    } catch (e) {}
  }

  dispatch({
    type: FETCH_LANGUAGE_SUCCESS,
    payload: defaultLanguageData
  });
};

export const editLanguage = (lang, method) => async (dispatch) => {
  dispatch({
    type: EDIT_LANGUAGE,
    payload: { lang, method }
  });

  const supabase = getSupabase();
  if (supabase) {
    try {
      if (method === 'Add') {
        await supabase.from('languages').insert([lang]);
      } else if (method === 'Delete') {
        await supabase.from('languages').delete().eq('id', lang.id);
      } else {
        await supabase.from('languages').update(lang).eq('id', lang.id);
      }
    } catch (e) {}
  }
};
